import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";
import { TBoardRefProp } from "../types/TBoardRefProp";

export const useUnlinkBoardIntegrationService = (props: TBoardRefProp) =>
  useHttpClientDispatchable({
    url: `/boardIntegration/${props.boardRef}/unlink`,
    method: RequestMethodEnum.DELETE,
  });
